import React from 'react';
import { utility } from '../framework/utility/utilityProvider';
import MyStatusCell from './MyStatusCell';
const getColor = (typeName) => {
    if (!typeName) return "#9CA3AF";

    const name = typeName.toLowerCase().trim();

    // Fixed color mapping
    if (name === "tvod") return "#3F51B5"
    if (name === "svod") return "#4CAF50";
    if (name === "avod") return "#FFC107";

    // fallback (existing logic)
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff;
        color += ("00" + value.toString(16)).slice(-2);
    }

    return color;
};

export const TransmissionTypeStatusCell = (props) => {
    const { dataItem, field } = props;

    const transmissionType = utility.getNestedValue(dataItem, field);
    const typeName = transmissionType?.Name || transmissionType || "N/A";

    const tileBackColor = getColor(typeName);

    return (
        <MyStatusCell
            {...props}
            title={typeName}
            titleColor="white"
            tileBackColor={tileBackColor}
        />
    );
};
